/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Level_Jumpy_Tortoise_ValueInputs */

const fr_level_jumpy_tortoise_value = /** @type {(inputs: Level_Jumpy_Tortoise_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Historique de notification`)
};

/**

* @param {Level_Jumpy_Tortoise_ValueInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const level_jumpy_tortoise_value = /** @type {((inputs?: Level_Jumpy_Tortoise_ValueInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Level_Jumpy_Tortoise_ValueInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_level_jumpy_tortoise_value(inputs)
});